import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { drupalPermsInclude, isCourtDrive } from '../../../../util/globalUtils';
import loadingBarImage from '../../../../images/loadingBar.gif';


const Document = ({
  document,
  index,
  downloadFile,
  emailPartPopup,
  printPreview,
  createBlogPost,
  ocrDownload,
  buyPdf,
}) => {
  let row = null;

  if (document.is_cached) {
    row = (
      <table>
        <tbody>
          <tr className="no-filter-search docket-document">
            <td style={{ whiteSpace: 'nowrap' }}>
              <div id="download"
                   title="Download File"
                   onClick={() => downloadFile(document)}>
                <span className="download icon" />
              </div>
              <div className="email-pdf"
                   onClick={() => emailPartPopup(document.friendly_name, document.docket_no, document.number)}
                   id="email"
                   title="Email">
                <span className="email icon" />
              </div>
              <div
                 onClick={() => printPreview(document)}
                 id="print"
                 className="print"
                 title="Print preview">
                <span className="preview icon" />
              </div>
              <div className="permission-check-links">
                { drupalPermsInclude('Public Link to Docket Parts PDFs') && !_.isEmpty(document.public_pdf_link) && (
                  <div className="menu">
                    <div className="ui delayed dropdown item">
                      <a title="Public Download Link" href={document.public_pdf_link}>
                        <span className="public link icon" />
                      </a>
                      <div className="menu" style={{ display: 'none' }}>
                        <div className="item">
                          For Public Download Link:
                        </div>
                        <div className="item">
                          <a href={document.public_pdf_link}>
                            <span className="pdf icon" />Right-Click Copy This Link
                          </a>
                        </div>
                        <div className="item">
                          Or copy HTML Code below:
                        </div>
                        <div className="item">
                          <textarea onFocus={e => e.target.select()}>
                            { document.public_pdf_link }
                          </textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                { !isCourtDrive() && drupalPermsInclude('subscribe to blog') && (
                  <div title="Create blog post" onClick={() => createBlogPost(document)}>
                    <span className="blog-post icon" />
                  </div>
                )}
                { drupalPermsInclude('Docket Parts OCR Link') && (
                  <div id="download-OCR" title="Download OCR" onClick={() => ocrDownload(document)}>
                    <span className="download ocr icon" />
                  </div>
                )}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  } else if (document.isLoading) {
    row = (
      <div className="loading-bar">
        <img src={loadingBarImage} alt="" />
      </div>
    );
  } else {
    row = (
      <button
        onClick={() => buyPdf(document.number)}
        className="form-submit green"
      >
        Buy ${document.cost}
      </button>
    );
  }

  return (
    <tr className="odd no-filter-search" key={`document docket-detail-${index}`}>
      <td />
      <td>{ document.number }</td>
      <td>{ document.description_html || 'Docket' }</td>
      <td>{ document.pages }</td>
      <td style={{ whiteSpace: 'nowrap' }}>
        { row }
      </td>
    </tr>
  );
};

Document.propTypes = {
  document: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  downloadFile: PropTypes.func.isRequired,
  emailPartPopup: PropTypes.func.isRequired,
  printPreview: PropTypes.func.isRequired,
  createBlogPost: PropTypes.func.isRequired,
  ocrDownload: PropTypes.func.isRequired,
  buyPdf: PropTypes.func.isRequired,
};

export default Document;



// WEBPACK FOOTER //
// ./src/components/case/claims/claimsEntries/Document.jsx